import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { HistoryEffects } from './history.effects';
import { IHistoryFeature } from './history.feature.state';
import { HistoryReducer } from './history.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IHistoryFeature>('HistoryFeature'), HistoryReducer),
    EffectsModule.forFeature([HistoryEffects]),
  ],
})
export class HistoryStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: HistoryStateModule
  ) {
    if (parentModule) {
      throw new Error('HistoryStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
